import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

const INTEGRATION_FIELDS = `
	id
	companyHotelId
	type
	provider
	providers { provider label available }
	status
	enabled
	hotelCode
	username
	monthsAhead
	sourceTimezone
	historyMonthsBack
	interval
	startAt
	credential { saved savedAt savedBy }
	lastRunAt
	lastRunRecords
	lastRunCancellations
	nextRunAt
	recentRuns { tone startedAt result }
	catalogue { ready busy roomTypes ratePlans rooms syncedAt }
	backfill {
		windowFrom windowTo days lockHours callsPerHour callsRemaining lockedUntil runningUntil
		streams { kind partDays partMonths partsPerClick doneParts parts { number from to state } }
		clicks {
			clickedAt result message
			stays { firstPart lastPart doneParts partNumbers }
			cancellations { firstPart lastPart doneParts partNumbers }
			technical { requestId httpStatus providerCode text }
		}
	}
	pricing {
		recommendationSubmit
		automaticSubmitMode
		lastPush { createdAt type prices days state }
	}
`;

export const FIND_COMPANY_INTEGRATIONS_QUERY: GraphQL = {
	name: 'findCompanyIntegrations',
	gql: gql`
		query findCompanyIntegrations {
			findCompanyIntegrations {
				companyHotelId
				name
				integrations { ${INTEGRATION_FIELDS} }
			}
		}
	`,
};

export const FIND_COMPANY_HOTEL_INTEGRATIONS_QUERY: GraphQL = {
	name: 'findCompanyHotelIntegrations',
	gql: gql`
		query findCompanyHotelIntegrations($companyHotelId: Long!) {
			findCompanyHotelIntegrations(companyHotelId: $companyHotelId) {
				companyHotelId
				name
				integrations { ${INTEGRATION_FIELDS} }
			}
		}
	`,
};

export const FIND_INTEGRATION_RUNS_QUERY: GraphQL = {
	name: 'findIntegrationRuns',
	gql: gql`
		query findIntegrationRuns($integrationId: Long!) {
			findIntegrationRuns(integrationId: $integrationId) {
				runs7Days
				runs30Days
				failed7Days
				partlyFailed7Days
				runs {
					id startedAt finishedAt durationSeconds trigger result records message
					technical { requestId httpStatus providerCode text }
				}
			}
		}
	`,
};

export const SAVE_INTEGRATION_MUTATION: GraphQL = {
	name: 'saveIntegration',
	gql: gql`
		mutation saveIntegration($input: SaveIntegrationInput!) {
			saveIntegration(input: $input) { ${INTEGRATION_FIELDS} }
		}
	`,
};

export const TEST_INTEGRATION_CONNECTION_MUTATION: GraphQL = {
	name: 'testIntegrationConnection',
	gql: gql`
		mutation testIntegrationConnection($input: SaveIntegrationInput!) {
			testIntegrationConnection(input: $input) {
				success
				exception
			}
		}
	`,
};

export const SET_INTEGRATION_ENABLED_MUTATION: GraphQL = {
	name: 'setIntegrationEnabled',
	gql: gql`
		mutation setIntegrationEnabled($integrationId: Long!, $enabled: Boolean!) {
			setIntegrationEnabled(integrationId: $integrationId, enabled: $enabled) { ${INTEGRATION_FIELDS} }
		}
	`,
};

export const RUN_INTEGRATION_BACKFILL_MUTATION: GraphQL = {
	name: 'runIntegrationBackfill',
	gql: gql`
		mutation runIntegrationBackfill($integrationId: Long!) {
			runIntegrationBackfill(integrationId: $integrationId) { ${INTEGRATION_FIELDS} }
		}
	`,
};

export const REFRESH_INTEGRATION_ROOMS_MUTATION: GraphQL = {
    name: 'refreshIntegrationRooms',
    gql: gql`
        mutation refreshIntegrationRooms($integrationId: Long!) {
            refreshIntegrationRooms(integrationId: $integrationId) {
                result message roomTypes ratePlans rooms syncedAt retryAt runId
            }
        }
    `,
};
